import { atom } from "jotai";

// Bad move, it should had been a Zustand store instead.
// At this point it's hard to replace, so we'll keep it for now.
export const currentEditionIdAtom = atom<string>("");
